import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const calendarThemeToken: any = {
  //========================= COLOR =================================/
  colorTextDisabled: variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],
  colorTextHeading: variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],

  //========================= SIZE =================================/
  padding: 16,
  paddingSM: 24,
  paddingXS: 0,
  paddingXXS: 0,
  controlHeightLG: 40,
  controlHeightSM: 32,
  borderRadiusLG: 2,
  borderRadiusSM: 2,

  //========================= FONT =================================/
  fontFamily: variableTypography["BodyMediumFontFamily"],
  fontWeightStrong: variableTypography["BodyMediumFontWeight"],
  fontHeightSM: variableTypography["BodyMediumLineHeight"],
  fontSize: variableTypography["BodyMediumFontSize"],
  lineHeight: variableTypography["BodyMediumLineHeight"],
};
